// extracted by mini-css-extract-plugin
module.exports = {"outerbox":"searchInput__outerbox___1tiHt","searchInput":"searchInput__searchInput___pcN97","icon":"searchInput__icon___1IJwZ"};